export enum EntityType {
  district = "district",
  school = "school",
  classroom = "classroom",
  student = "student",
}
